// Servicio para manejar datos de regionales, áreas y materias en localStorage
// y el regional activo seleccionado por el usuario.

const REGIONALES_KEY = 'app_regionales';
const AREAS_KEY = 'app_areas';
const MATERIAS_KEY = 'app_materias';
const ACTIVE_REGIONAL_KEY = 'app_regional_activa';
const ACTIVE_REGIONAL_ID_KEY = 'app_regional_activa_id';
const FEATURE_FLAGS_KEY = 'app_feature_flags';

const safeSetItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('❌ Error guardando en localStorage:', key, error);
  }
};

const safeGetItem = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    console.error('❌ Error leyendo desde localStorage:', key, error);
    return fallback;
  }
};

const RegionalService = {
  setRegionalData({ regionales = [], areas = [], materias = [] }) {
    safeSetItem(REGIONALES_KEY, regionales);
    safeSetItem(AREAS_KEY, areas);
    safeSetItem(MATERIAS_KEY, materias);
  },

  getRegionales() {
    return safeGetItem(REGIONALES_KEY, []);
  },

  getAreas() {
    return safeGetItem(AREAS_KEY, []);
  },

  getMaterias() {
    return safeGetItem(MATERIAS_KEY, []);
  },

  setActiveRegional(regional) {
    safeSetItem(ACTIVE_REGIONAL_KEY, regional || null);
    const regId = regional?.id || regional?.Id || null;
    safeSetItem(ACTIVE_REGIONAL_ID_KEY, regId);
  },

  getActiveRegional() {
    return safeGetItem(ACTIVE_REGIONAL_KEY, null);
  },

  getActiveRegionalId() {
    return safeGetItem(ACTIVE_REGIONAL_ID_KEY, null);
  },

  setFeatureFlags(flags) {
    safeSetItem(FEATURE_FLAGS_KEY, Array.isArray(flags) ? flags : []);
  },

  getFeatureFlags() {
    return safeGetItem(FEATURE_FLAGS_KEY, []);
  },

  clearRegionalData() {
    try {
      localStorage.removeItem(REGIONALES_KEY);
      localStorage.removeItem(AREAS_KEY);
      localStorage.removeItem(MATERIAS_KEY);
      localStorage.removeItem(ACTIVE_REGIONAL_KEY);
      localStorage.removeItem(ACTIVE_REGIONAL_ID_KEY);
      localStorage.removeItem(FEATURE_FLAGS_KEY);
    } catch (error) {
      console.error('❌ Error limpiando datos de regionales en localStorage:', error);
    }
  }
};

export default RegionalService;
